import { render, staticRenderFns } from "./AccessRestricted.vue?vue&type=template&id=d2e5693a&scoped=true&"
import script from "./AccessRestricted.vue?vue&type=script&lang=js&"
export * from "./AccessRestricted.vue?vue&type=script&lang=js&"
import style0 from "./AccessRestricted.vue?vue&type=style&index=0&id=d2e5693a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e5693a",
  null
  
)

export default component.exports